/*
  AMUMIN: App-submenu in de kop (desktop). Zelfde gedrag als het bestaande menu (hover-menu.js):
  openen bij aanwijzen, sluiten met een korte vertraging. Daarnaast met het toetsenbord:
  focus op "App" of in het paneel opent het, Escape sluit en zet de focus terug.
  Opent het gedeelde Shop-menu, dan sluit dit paneel (en andersom).
*/
(function () {
  if (window.__amuminAppMenu) return;
  window.__amuminAppMenu = true;

  function init() {
    var item = document.querySelector('[data-am-appmenu]');
    if (!item) return;
    var panel = item.querySelector('[data-am-appmenu-panel]');
    var trigger = item.querySelector('#HeaderMenu-amumin-app');
    if (!panel || !trigger) return;
    var shared = document.getElementById('MegaDropdown-shared');
    var timer;
    var desktop = window.matchMedia('(min-width: 990px)');

    function open() {
      if (!desktop.matches) return;
      clearTimeout(timer);
      if (shared) shared.classList.remove('is-open');
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close(now) {
      clearTimeout(timer);
      var done = function () {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };
      if (now) done();
      else timer = setTimeout(done, 200);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', function () {
      close(false);
    });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) close(true);
    });
    item.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        close(true);
        trigger.focus();
      }
    });

    // Zolang de muis of focus in het App-menu staat, blijft het gedeelde menu dicht
    // (anders schuift het er bij een klik overheen).
    if (shared && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (shared.classList.contains('is-open') && panel.classList.contains('is-open') && (item.matches(':hover') || item.contains(document.activeElement))) {
          shared.classList.remove('is-open');
        }
      }).observe(shared, { attributes: true, attributeFilter: ['class'] });
    }

    // Het gedeelde menu van de andere links: dit paneel dicht zodra dat opent.
    Array.prototype.forEach.call(document.querySelectorAll('.mega-trigger'), function (t) {
      t.addEventListener('mouseenter', function () {
        if (!item.matches(':hover')) close(true);
      });
    });

    // Wachtlijst uit het menu: paneel dicht voordat het venster opent.
    Array.prototype.forEach.call(panel.querySelectorAll('[data-am-waitlist-open]'), function (a) {
      a.addEventListener('click', function () {
        close(true);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
